import { HomesOnboardingTypeSelectionPage as Page } from "apps/propertySelection/importMethod/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(Page, "ImportMethodPage");
